module.exports = __webpack_public_path__ + "img/summary_sm.77c26db7.png";